import React from 'react'

const FloatingEmojis = () => {
  const emojis = ['🍎', '⏰', '✨', '💭', '🎯', '🌟', '💡', '🎨']
  
  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden">
      {emojis.map((emoji, index) => (
        <div
          key={index}
          className="floating-emoji"
          style={{
            left: `${Math.random() * 100}%`,
            top: `${Math.random() * 100}%`,
            animationDelay: `${Math.random() * 6}s`,
            animationDuration: `${6 + Math.random() * 4}s`
          }}
        >
          {emoji}
        </div>
      ))}
    </div>
  )
}

export default FloatingEmojis 